import PatientOverviewKnowledgeProgress from 'dashboard/templates/views/Patient/Knowledge/PatientOverviewKnowledgeProgress';

export default {
  path: 'progress',
  name: 'PatientRecordKnowledgeProgress',
  component: PatientOverviewKnowledgeProgress,
  meta: {
    // title: 'Patient Record - Knowledge - Progress',
    // title: t => `${t('patient.patientRecord')} - ${t('nutritionBarriers.knowledgeAnswer', 'questionnaires')} - ${t('journeyProgress.progress')}`,
    // title: 'Increase your Knowledge - Progress',
    title: t => `${t('screens.increaseYourKnowledgeSettingScreen', 'app_mobile')} - ${t('journeyProgress.progress')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
